/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2022-03-24 13:51:51
 * @LastEditors: 廖图图
 * @LastEditTime: 2022-03-24 14:05:01
 */
import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import qs from "qs"; // 按需导入qs模块:post请求用到
const power = {
  /**
   * 变压器厂区树
   */
  getHPTransformerClassTree() {
    let params = {};
    return axios.post(
      base.power.getHPTransformerClassTree,
      qs.stringify(params)
    );
  },
  /**
   * 变压器投退界面数据
   * @param {*} meterId meterId
   * @param {*} timeType 时间类型，2（月）d
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   */
  getTransformerInOut(meterId, timeType, startTime, endTime) {
    let params = {
      meterId: meterId,
      timeType: timeType,
      startTime: startTime,
      endTime: endTime,
    };
    return axios.post(base.power.getTransformerInOut, qs.stringify(params));
  },
  /**
   * (3)、月铁损节省电量对应节省费用
   * @param {*} meterIds 变压器计量点id数组
   * @param {*} energyType 能源类型，电1
   * @param {*} timeType 时间类型，2（月）
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   */
  getMonthEnergyToCharge(meterIds, energyType, timeType, startTime, endTime) {
    let params = {
      meterIds: JSON.stringify(meterIds),
      energyType: energyType,
      timeType: timeType,
      startTime: startTime,
      endTime: endTime,
    };
    return axios.post(base.power.getMonthEnergyToCharge, qs.stringify(params));
  },
};

export default power;
